/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

interface Wizard {
  token: string;
  step: string;
}

export interface WizardProps {
  wizard: Wizard;
}

const withWizardProps = <P extends object>(Component: React.ComponentType<P & WizardProps>) =>
  class withWizardProps extends React.Component<P & RouteComponentProps<Wizard>> {

    render() {
      const { match } = this.props
      let token = '0'
      let step = 'step'

      console.log(match)

      if (match) {
        token = match.params.token
        step = match.params.step
      }

      return (
        <Component
          {...this.props as P}
          wizard={{ token, step }}
        />
      )
    }
  }

export default withWizardProps